import { useState, useEffect } from "react";
import { api, ApiError } from "../lib/api";

interface Props { onDone: () => void }

export default function Login({ onDone }: Props) {
  const [requiresPassword, setRequiresPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api<{ requiresPassword: boolean }>("/api/auth/status").then((s) => {
      setRequiresPassword(s.requiresPassword);
    }).catch(() => {});
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({ password: password || undefined, code }),
      });
      onDone();
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : "Login failed";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <form onSubmit={submit} className="card w-full max-w-sm space-y-4 p-6">
        <div className="text-lg font-semibold">Sign in</div>
        {requiresPassword && (
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Password</label>
            <input type="password" autoComplete="current-password" value={password}
                   onChange={(e) => setPassword(e.target.value)} className="w-full" required />
          </div>
        )}
        <div>
          <label className="mb-1 block text-sm font-medium text-slate-700">
            Authenticator code (or recovery code)
          </label>
          <input
            type="text" inputMode="text" autoComplete="one-time-code" autoFocus
            value={code} onChange={(e) => setCode(e.target.value)} className="w-full"
            placeholder="123456 or XXXX-XXXX-XXXX" required
          />
        </div>
        {error && <div className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
        <button type="submit" disabled={submitting} className="btn-primary w-full">
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
